<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="36" height="36" viewBox="0 0 36 36">
        <defs>
            <clipPath id="clip-MD">
                <rect width="36" height="36"/>
            </clipPath>
        </defs>
        <g id="MD" clip-path="url(#clip-MD)">
            <rect width="36" height="36" class="svg-block-background-color"/>
            <g id="Group_3" data-name="Group 3" transform="translate(7378.76 -627.586)">
                <rect id="Rectangle_10110" data-name="Rectangle 10110" width="36" height="36" transform="translate(-7378.76 627.586)" fill="#263238" opacity="0"/>
                <g id="Group_14573" data-name="Group 14573" transform="translate(-7550.76 490.586)">
                    <g id="Rectangle_10124" data-name="Rectangle 10124" transform="translate(172 143)" fill="none" class="svg-stroke-color" stroke-width="1">
                        <rect width="36" height="24" stroke="none"/>
                        <rect x="0.5" y="0.5" width="35" height="23" fill="none"/>
                    </g>
                    <path id="Path_4344" :class="secondaryColor" data-name="Path 4344" d="M-12.812,0V-12.885h3.894L-6.581-4.1l2.312-8.789h3.9V0H-2.784V-10.143L-5.341,0h-2.5L-10.4-10.143V0Zm15.2-12.885H7.143a9.285,9.285,0,0,1,2.452.246,4.309,4.309,0,0,1,1.942,1.187,5.629,5.629,0,0,1,1.23,2.087,9.509,9.509,0,0,1,.422,3.045,8.468,8.468,0,0,1-.4,2.742A5.681,5.681,0,0,1,11.415-1.3,4.573,4.573,0,0,1,9.587-.272,7.871,7.871,0,0,1,7.284,0h-4.9Zm2.6,2.18v8.534H6.932a7.088,7.088,0,0,0,1.573-.123,2.4,2.4,0,0,0,1.05-.536,2.728,2.728,0,0,0,.681-1.244,8.406,8.406,0,0,0,.264-2.36,7.7,7.7,0,0,0-.264-2.294A2.948,2.948,0,0,0,9.5-9.976a2.476,2.476,0,0,0-1.2-.606,11.8,11.8,0,0,0-2.136-.123Z" transform="translate(189.812 162)" />
                </g>
            </g>
        </g>
    </svg>

</template>

<script>
export default {
    name: "mdIcon",
    computed :{
        secondaryColor() {
            return 'svg-secondary-color';
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/info-popup/mdIcon.vue